module.exports = __webpack_public_path__ + "img/cover.c825a9c4.png";